module.exports = __webpack_public_path__ + "static/media/play-button.db414ff1.svg";